<template>
  <v-container
    id="wizard"
    tag="section"
  >
    <base-material-wizard
      v-model="tab"
      :available-steps="availableSteps"
      :items="tabs"
      :loading="loading"
      class="mx-auto"
      color="amber"
      @click:next="next"
      @click:prev="tab--"
      @tab:change="save"
    >
      <v-tab-item class="pb-12">
        <form
          action=""
          data-vv-scope="group"
        >
          <div class="text-center display-1 font-weight-light mb-6">
            Specify Group Details
          </div>
          <v-row
            class="mx-auto"
            justify="space-around"
          >
            <v-col cols="12">
              <v-text-field
                v-model="item.groupName"
                v-validate="'required'"
                :error-messages="formErrors.GroupName"
                data-vv-name="groupName"
                label="Group"
                validate-on-blur
                @change="handleGroupChange"
              />
            </v-col>
          </v-row>
          <v-row
            class="mx-auto"
            justify="space-around"
          >
            <v-col cols="12">
              <v-text-field
                v-model="item.legalBusinessName"
                v-validate="'required'"
                :error-messages="formErrors.LegalBusinessName"
                data-vv-name="legalBusinessName"
                label="Legal Business Name"
                validate-on-blur
                @change="handleGroupChange"
              />
            </v-col>
          </v-row>
          <v-row
            class="mx-auto"
            justify="space-around"
          >
            <v-col cols="12">
              <v-text-field
                v-model="item.businessAddress"
                v-validate="'required'"
                :error-messages="formErrors.BusinessAddress"
                data-vv-name="businessAddress"
                label="Business Address"
                validate-on-blur
                @change="handleGroupChange"
              />
            </v-col>
          </v-row>
          <v-row
            class="mx-auto"
            justify="space-around"
          >
            <v-col cols="6">
              <v-text-field
                v-model="item.businessCity"
                v-validate="'required'"
                :error-messages="formErrors.BusinessCity"
                data-vv-name="businessCity"
                label="Business City"
                validate-on-blur
                @change="handleGroupChange"
              />
            </v-col>
            <v-col cols="3">
              <v-text-field
                v-model="item.businessState"
                v-validate="'required'"
                :error-messages="formErrors.BusinessState"
                data-vv-name="businessState"
                label="Business State"
                validate-on-blur
                @change="handleGroupChange"
              />
            </v-col>
            <v-col cols="3">
              <v-text-field
                v-model="item.businessZip"
                v-validate="'required'"
                :error-messages="formErrors.BusinessZip"
                data-vv-name="businessZip"
                label="Business Zip"
                validate-on-blur
                @change="handleGroupChange"
              />
            </v-col>
          </v-row>
          <v-row
            class="mx-auto"
            justify="space-around"
          >
            <v-col cols="12">
              <v-text-field
                v-model="item.taxId"
                v-validate="'required'"
                :error-messages="formErrors.TaxId"
                data-vv-name="taxId"
                label="Tax ID"
                validate-on-blur
                @change="handleGroupChange"
              />
            </v-col>
          </v-row>
          <v-row
            class="mx-auto"
            justify="space-around"
          >
            <v-col cols="12">
              <v-text-field
                v-model="item.hrAdminName"
                v-validate="'required'"
                :error-messages="formErrors.HRAdminName"
                data-vv-name="hrAdminName"
                label="HR Admin Name"
                validate-on-blur
                @change="handleGroupChange"
              />
            </v-col>
          </v-row>
          <v-row
            class="mx-auto"
            justify="space-around"
          >
            <v-col cols="12">
              <v-text-field
                v-model="item.hrAdminEmail"
                v-validate="'required'"
                :error-messages="formErrors.HRAdminEmail"
                data-vv-name="hrAdminEmail"
                label="HR Admin Email"
                validate-on-blur
                @change="handleGroupChange"
              />
            </v-col>
          </v-row>
          <v-row
            class="mx-auto"
            justify="space-around"
          >
            <v-col cols="12">
              <v-text-field
                v-model="item.hrAdminPhone"
                v-validate="'required'"
                :error-messages="formErrors.HRAdminPhone"
                data-vv-name="hrAdminPhone"
                label="HR Admin Phone"
                validate-on-blur
                @change="handleGroupChange"
              />
            </v-col>
          </v-row>
          <v-row
            class="mx-auto"
            justify="space-around"
          >
            <v-col cols="12">
              <v-text-field
                v-model="item.hrAdminName2"
                v-validate="'required'"
                :error-messages="formErrors.HRAdminName2"
                data-vv-name="hrAdminName2"
                label="HR Admin Name (2)"
                validate-on-blur
                @change="handleGroupChange"
              />
            </v-col>
          </v-row>
          <v-row
            class="mx-auto"
            justify="space-around"
          >
            <v-col cols="12">
              <v-text-field
                v-model="item.hrAdminEmail2"
                v-validate="'required'"
                :error-messages="formErrors.HRAdminEmail2"
                data-vv-name="hrAdminEmail2"
                label="HR Admin Email (2)"
                validate-on-blur
                @change="handleGroupChange"
              />
            </v-col>
          </v-row>
          <v-row
            class="mx-auto"
            justify="space-around"
          >
            <v-col cols="12">
              <v-text-field
                v-model="item.hrAdminPhone2"
                v-validate="'required'"
                :error-messages="formErrors.HRAdminPhone2"
                data-vv-name="hrAdminPhone2"
                label="HR Admin Phone (2)"
                validate-on-blur
                @change="handleGroupChange"
              />
            </v-col>
          </v-row>
        </form>
      </v-tab-item>

      <v-tab-item class="pb-12">
        <form
          action=""
          data-vv-scope="broker"
        >
          <div class="text-center display-1 font-weight-light mb-6">
            Select a Broker
          </div>
          <v-row
            class="mx-auto"
            justify="space-around"
          >
            <v-col cols="12">
              <base-resource-select
                v-if="item"
                label="Broker"
                item-text="broker"
                item-value="id"
                bind-text="broker"
                bind-value="brokerId"
                :bind-item.sync="brokerGroup"
                :error-messages="formErrors.BrokerId"
                :resource="brokerResource"
                @change="handleBrokerChange"
              />
            </v-col>
          </v-row>
        </form>
      </v-tab-item>

      <v-tab-item class="pb-12">
        <form
          action=""
          data-vv-scope="roles"
        >
          <v-row
            class="mx-auto"
            justify="space-around"
          >
            <v-col cols="12">
              <base-resource-grid
                color="amber"
                icon="mdi-account-card-details-outline"
                plural-name="Roles"
                singular-name="Role"
                allow-expand
                :headers="headers"
                :resource="groupRoleResource"
                :fetch-method="getGroupRoleList"
                :static-assignments="groupRoleStaticAssignments"
                @handleAction="handleAction"
              >
                <template v-slot:editForm="bindings">
                  <v-row>
                    <v-col
                      cols="12"
                    >
                      <base-resource-select
                        v-if="item"
                        label="Role"
                        item-text="troodyRoleName"
                        item-value="id"
                        bind-text="troodyRoleName"
                        bind-value="roleId"
                        :bind-item="bindings.editedItem"
                        :error-messages="bindings.formErrors.RoleId"
                        :resource="identAuthRoleResource"
                        @change="handleRoleChange"
                      />
                      <base-resource-select
                        v-if="item && roleIdSelected"
                        :key="userRefreshKey"
                        label="User"
                        item-text="userName"
                        item-value="id"
                        bind-text="userName"
                        bind-value="userId"
                        sort-by="userName"
                        :bind-item="bindings.editedItem"
                        :error-messages="bindings.formErrors.UserId"
                        :fetch-method="getIdentAuthUserRoleList"
                      />
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col
                      cols="12"
                    >
                      <v-checkbox
                        v-model="bindings.editedItem.isPrimary"
                        label="Is Primary"
                      />
                    </v-col>
                  </v-row>
                </template>
              </base-resource-grid>
            </v-col>
          </v-row>
        </form>
      </v-tab-item>
      <template v-slot:buttons>
        <v-btn
          color="amber darken-1"
          @click="finished"
        >
          Close
        </v-btn>
      </template>
    </base-material-wizard>
    <base-material-snackbar
      v-model="displayError"
      type="error"
      v-bind="{
        top: true,
        right: true
      }"
    >
      {{ errorMessage }}
    </base-material-snackbar>
  </v-container>
</template>

<script>
  import TroodyApi from '@/services/troody/TroodyApi'
  import { extractFormErrors, getErrorTitle } from '@/services/ErrorHandlers'

  export default {
    name: 'GroupWizard',

    props: {
      editedItem: {
        type: Object,
        default: null,
      },
    },

    data: () => ({
      tab: 0,
      tabs: ['Group', 'Broker', 'Roles'],
      item: null,

      brokerGroup: {},
      brokerResource: new TroodyApi('broker/'),

      headers: [
        {
          text: 'Name',
          value: 'userName',
        },
        {
          text: 'Role',
          value: 'troodyRoleName',
        },
        {
          text: 'Primary',
          value: 'isPrimary',
        },
      ],

      loading: false,
      errorMessage: null,
      displayError: false,

      roleIdSelected: null,

      userRefreshKey: 0,

      groupDirty: false,
      brokerDirty: false,
      availableSteps: [0],
      formErrors: {},

      groupResource: new TroodyApi('group/'),

      brokerGroupResource: new TroodyApi('brokerGroup/'),

      groupRoleResource: new TroodyApi('groupRole/'),

      identAuthRoleResource: new TroodyApi('identAuthRole/'),

      identAuthUserRoleResource: new TroodyApi('identAuthUserRole/'),

    }),

    computed: {
      scope () {
        if (this.tab === 0) return 'group'
        else if (this.tab === 2) return 'roles'
        return 'broker'
      },

      groupRoleStaticAssignments () {
        return { groupId: this.item.id }
      },

      dataDirty () {
        return this.groupDirty || this.brokerDirty
      },
    },

    watch: {
      editedItem (val) {
        this.initialize()
      },
    },

    created () {
      this.initialize()
    },

    methods: {
      initialize () {
        this.item = Object.assign({}, this.editedItem)
        this.brokerGroup = {}

        this.groupDirty = false
        this.brokerDirty = false
        this.formErrors = {}

        this.loadBrokerGroup()

        this.tab = 0
        this.roleIdSelected = null
      },

      setAvailableSteps () {
        const steps = [0]

        if (this.item.groupName) {
          steps.push(1)
        }

        // Once they've got a group name entered they can edit either the broker or the roles
        if ((this.brokerGroup || {}).brokerId && steps.includes(1)) {
          steps.push(2)
          steps.push(3)
        }

        this.availableSteps = steps
      },

      handleAction (action, data) {
        if (action === 'edit') {
          // When editing, we are assuming a role id is now selected associated with the data being edited
          this.roleIdSelected = data.roleId
        }
      },

      handleGroupChange () {
        this.groupDirty = true
        this.setAvailableSteps()
      },

      handleRoleChange (role) {
        this.roleIdSelected = role.roleId
        this.userRefreshKey += 1 // Force the component to refresh
        this.setAvailableSteps()
      },

      handleBrokerChange (broker) {
        this.brokerDirty = true
        this.setAvailableSteps()
      },

      loadBrokerGroup () {
        this.brokerGroup = {}
        if (this.item.id) {
          this.brokerGroupResource.query({ groupId: this.item.id })
            .then(data => {
              if (data && data.length) {
                this.brokerGroup = data[0]
              }
              this.setAvailableSteps()
            })
            .catch((error) => {
              this.showError(error, 'Failed to load broker!')
            })
        }
      },

      finished () {
        this.save()
          .then(() => {
            this.formErrors = {}
            this.$emit('wizard:finished')
          })
      },

      next () {
        this.loading = true
        this.save()
          .then(() => {
            this.loading = false
            if (this.tab === this.tabs.length - 1) {
              this.finished()
            } else {
              this.tab++
            }
          })
      },

      handleError (error) {
        this.loading = false
        this.formErrors = extractFormErrors(error)
        if (this.formErrors) {
          this.showError(getErrorTitle(error), 'Failed to save!')
        } else {
          this.formErrors = {}
          this.showError(error, 'Failed to save!')
        }
      },

      showError (error, msg) {
        console.log(error)
        this.errorMessage = (error || msg)
        this.displayError = true
      },

      saveGroup () {
        const promise = new Promise((resolve, reject) => {
          this.groupResource.save(this.item)
            .then((data) => {
              this.item = data
              this.groupDirty = false
              this.save() // Save anything left for the other steps
              this.$emit('group:saved', data)
              resolve(data)
            })
            .catch((error) => {
              this.tab = 0
              reject(error)
            })
        })

        return promise
      },

      saveBroker () {
        const promise = new Promise((resolve, reject) => {
          if (this.item && this.item.id) {
            this.brokerGroup.groupId = this.item.id
            this.brokerGroupResource.save(this.brokerGroup)
              .then((data) => {
                this.brokerGroup = data
                this.brokerDirty = false
                this.save() // Save anything left for the other steps
                this.$emit('broker:saved', data)
                resolve(data)
              })
              .catch((error) => {
                this.tab = 1
                this.showError(error, 'Failed to save broker!')
                reject(error)
              })
          } else {
            reject(new Error('No group exists to save too!'))
          }
        })

        return promise
      },

      save () {
        const promise = new Promise((resolve, reject) => {
          if (this.dataDirty) {
            if (this.groupDirty) {
              this.saveGroup()
                .then((data) => {
                  resolve(data)
                })
                .catch((error) => {
                  this.handleError(error)
                  reject(error)
                })
            } else {
              if (this.brokerDirty) {
                this.saveBroker()
                  .then((data) => {
                    resolve(data)
                  })
                  .catch((error) => {
                    this.handleError(error)
                    reject(error)
                  })
              }
            }
          } else {
            resolve({ dataDirty: false })
          }
        })

        return promise
      },

      validateForm (scope) {
        return this.$validator.validateAll(scope)
      },

      getGroupRoleList () {
        return this.groupRoleResource.query({ groupId: this.item.id })
      },

      getIdentAuthUserRoleList () {
        return this.identAuthUserRoleResource.query({ identAuthRoleId: this.roleIdSelected })
      },
    },
  }
</script>
